import { LngLat, YMap, YMapMarkerProps } from "@yandex/ymaps3-types";

interface IMapConstructorProps {
  container: HTMLElement;
  center?: LngLat;
  zoom?: number;
}

export default class Map {
  container: HTMLElement;
  ymap?: YMap | undefined;
  constructor({ container, center, zoom }: IMapConstructorProps) {
    if (!container) throw new Error("Контейнер не определён");

    this.container = container;
    this.createMap(center, zoom);
  }

  private static key = "ca4ab438-ce96-431f-9eb5-8441c2a35bb3";
  private static ymapIsReady = false;
  private static isLoading = false;
  private static loader: Promise<string>;

  static loadAPI() {
    if (!this.isLoading && !this.ymapIsReady) {
      this.loader = this.startLoad();
      return this.loader;
    } else return this.loader;
  }

  private static startLoad() {
    return new Promise<string>((resolve) => {
      this.isLoading = true;
      if (Map.ymapIsReady) {
        this.isLoading = false;
        resolve("loaded");
        return;
      }

      const script = document.createElement("script");
      script.src = `https://api-maps.yandex.ru/v3/?apikey=${this.key}&lang=ru_RU`;
      script.addEventListener("load", async () => {
        await ymaps3.ready;
        Map.ymapIsReady = true;
        this.isLoading = false;
        resolve("loaded");
      });
      document.body.append(script);
    });
  }

  static createDefaultMarker(MarkerUrl) {
    const marker = document.createElement("div");
    if(MarkerUrl){
        marker.innerHTML = `
        <img src="`+ MarkerUrl +`">`;
    } else{
        marker.innerHTML = `
            <svg class="icon" viewBox="0 0 34 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 17.002C0 26.3919 7.61203 34.0039 17.002 34.0039V48.0703C20.4268 45.7463 26.298 39.5081 29.4782 34.0039C32.6584 28.4997 34.0039 22.5062 34.0039 17.002C34.0039 7.61203 26.3919 0 17.002 0C7.61203 0 0 7.61203 0 17.002Z" fill="#4280EF"/>
            <circle cx="17.0033" cy="16.5124" r="10.8861" fill="white"/>
            </svg>`;
    }

    marker.className = "default-map-marker";

    return marker;
  }

  createMap(center = [37.617635, 55.755814] as LngLat, zoom = 15) {
    this.ymap = new ymaps3.YMap(
      this.container,
      {
        location: {
          center,
          zoom,
        },
      },
      [
        new ymaps3.YMapDefaultSchemeLayer({
          customization:[]
        }),
        new ymaps3.YMapDefaultFeaturesLayer({ zIndex: 1800 }),
      ]
    );
  }

  setLocation(center: LngLat, zoom = 15) {
    if (!this.ymap) return;

    this.ymap?.setLocation({
      center,
      zoom,
    });
  }

  async addDefaultMarker(coordinates: LngLat) {
    const { YMapDefaultMarker } = await ymaps3.import(
      "@yandex/ymaps3-markers@0.0.1"
    );
    this.ymap?.addChild(
      new YMapDefaultMarker({
        coordinates,
      })
    );
  }

  addMarker(
    coordinates: LngLat,
    content: HTMLElement,
    props?: Partial<YMapMarkerProps>
  ) {
    if (!this.ymap) return;

    const marker = new ymaps3.YMapMarker(
      {
        coordinates,
        draggable: false,
        ...props,
      },
      content
    );

    this.ymap.addChild(marker);
  }

  addMarkers(coordinates: LngLat[], content: (coords: LngLat) => HTMLElement) {
    coordinates.forEach((coords) => {
      console.log(coords);
      this.addMarker(coords, content(coords));
      
    });
  } 
}
